import React from "react";

const OudeBrowser = (props) => {
	return (
		<section className="o-page__main u-clear" role="main">
			<div className="c-section-wrap">
				<div className="c-section c-section--pink">
					<header className="c-section__header">
						<h2 className="title">Verouderde browser</h2>
					</header>
					<div className="c-section__body">
						<div className="c-content-block">
							Met een verouderde browser kun je onze website helaas niet meer (goed) gebruiken. We raden je aan om over te schakelen naar een nieuwere versie. Overstappen naar een andere browser kan natuurlijk ook.
							<br /><br />
							Download eenvoudig de nieuwste versie van je favoriete browser; de meest gebruikte zijn:
							<br />
							<a href="http://www.mozilla.org/nl/firefox/new" target="_blank"><i className="fa fa-external-link"/> Firefox</a>
							<br />
							<a href="http://windows.microsoft.com/nl-nl/internet-explorer/download-ie" target="_blank"><i className="fa fa-external-link"/> Internet Explorer</a>
							<br />
							<a href="https://www.google.com/chrome/" target="_blank"><i className="fa fa-external-link"/> Chrome</a>
							<br />
							<a href="http://support.apple.com/nl_NL/downloads/#safari" target="_blank"><i className="fa fa-external-link"/> Safari</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default OudeBrowser;